import React from 'react';
import { Link } from 'react-router-dom';

const PortfolioHeader = () => {
    return(
        <>
            <div className="headerLinks clearfix">
                <ul>
                    <li><Link to="/portfolio/home">Home</Link></li>
                    <li><Link to="/portfolio/about">About me</Link></li>
                    <li><a id="skin-trigger" href="#" style={{display:'none'}}>
                        Change Skin <span>&#x25BC;</span>
                    </a>
                        
                    </li>
                </ul>

            </div>
            <div className="mainContainer">
                {/* <div className="try-buy">
                    <a href="how-can-we-help.php">&nbsp;</a>
                </div>*/}
                <div className="cclogo"><Link to="/portfolio/home" title="Creattively Charged - An Online Portfolio of Pro-Serve UX Team"><span>Creattively Charged - An Online Portfolio of Pro-Serve UX Team</span></Link></div>
                {/* <div className="gearsBg">
                    <div className="wheel8"></div>
                    <div className="wheel9"></div>
                    <div className="wheel10"></div>
                    <ul className="innerTopNav">
                        <li><Link to="/portfolio/frontend"><span>Front-end Stack</span></Link></li>
                        <li><Link to="/portfolio/uiux" className="active"><span>UI/UX</span></Link></li>
                        <li><Link to="/portfolio/middleware" ><span>Middleware</span></Link></li>
                        <li><Link to="/portfolio/digitalmarketing" ><span>Digital Marketing</span></Link></li>
                    </ul>
                </div> */}
            </div>
        </>
    )
}

export default PortfolioHeader;